import Head from "next/head";

import { LoginSplash } from "~/features/auth";

export default function Home() {
  return (
    <>
      <Head>
        <title>Plantura Single Sign-On</title>
        <meta
          name="description"
          content="Single Sign-On for Plantura Shop and Magazin"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Head>
      <LoginSplash />
    </>
  );
}
